<!-- Grab the toolbar if it exists and place it at the top -->
<ng-content select="glxy-page-toolbar" />

<ng-content select="glxy-page-below-toolbar" />

@if (isLoading) {
  <div class="loading-bar">
    <mat-progress-bar mode="indeterminate" />
  </div>
}

<div class="glxy-page-main-content" cdkScrollable (scroll)="onPageScroll($event)">
  <ng-content />
</div>
